<template>
  <div class="agent-search-page" :style="{ height: containerHeight }">
    <search-layout-input
      v-if="!searchObject.searchResult || isMobile"
      :assign-to-client="assignToClient"
      :search-layout-comps="searchLayoutComps"
      :search-type-options="searchTypeOptions"
      @on-search-clicked="onSearchClicked"
      @toggle-search-type="toggleSearchType"
    />
    <search-result-layout
      v-else
      :assign-to-client="assignToClient"
      :search-layout-comps="searchLayoutComps"
      :search-type-options="searchTypeOptions"
      @on-search-clicked="onSearchClicked"
      @toggle-search-type="toggleSearchType"
    />
    <search-page-content
      v-if="!isMobile"
      :search-object="searchObject"
      :assign-to-client="assignToClient"
      :top-header="getTopHeader"
      @open-display-property="showPropertyDetails"
      @load-more-clicked="assignSearchElement"
      @marker-clicked="onMapMarkerClicked"
    />
  </div>
</template>

<script>
import searchContent from '../../components/mixins/searchContent'
import { mapState } from 'vuex'

export default {
  mixins: [searchContent],

  computed: {
    ...mapState('common', ['isMobile']),
    ...mapState('client', ['assignToClient']),

    containerHeight() {
      return this.searchObject.searchResult ? 'calc(100vh - 48px)' : '100%'
    }
  },

  methods: {
    /**
     * Handles the click event of Search button
     * Sends request to the server to retrieve data based
     * on the options entered
     */
    onSearchClicked() {
      this.startSearch()
      if (this.isMobile) {
        this.$router.push({
          name: `agent-search-results`
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.agent-search-page
  overflow: hidden
  @media only screen and (max-width: 600px)
    height: 100%

#lazyLoader
  margin: 5rem 0 10rem
</style>
